import { Box, Paper, Typography } from "@mui/material"

const PaymentDeliveryBadge = () => {
  return (
    <Box
      sx={
        {
          /*width: "10rem"*/
        }
      }
    >
      <Paper
        elevation={0}
        sx={{
          background: "linear-gradient(180deg, #364E9D, #21326A)",
          p: 0.5,
        }}
      >
        <Typography fontSize="14px" lineHeight="14px" color="#FFFFFF">
          Envio imediato
        </Typography>
      </Paper>
    </Box>
  )
}

export default PaymentDeliveryBadge
